import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const categoryIds = [
    "188c3d8d-cbb6-4916-ab1b-32796e618c5c", // prod
    "32aaf942-e58d-4de1-8d10-be3c564c9c3e" // acc
];

export const VerlichtingFilter = ({ condensed }) => {
    const filter = useFilter("opties").find((category) =>
        categoryIds.includes(category.optiecategorieId)
    );
    const count = useCount("zoekopties");
    const [value, , onChange] = useField("zoekoptieIds");

    const options =
        filter?.zoekopties?.map(({ zoekoptieId, naam }) => ({
            id: zoekoptieId,
            displayName: naam,
            aantal: count[zoekoptieId]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-audio"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 3}
                datalayerKey="zoekoptieId"
                maxSize={0}
            />
        </Grid>
    );
};
